import { type NavigationAnchor } from "@/components/layout/types";
import {
  Module,
  PATH_AUDIT_LOGS,
  PATH_EMAIL_RECIPIENTS,
  PATH_EMAIL_TYPES,
  PATH_SENTRY_PLAYGROUND,
} from "@/constants";
import { useIsAdmin } from "@/modules/account/hooks/useIsAdmin";
import { usePermissions } from "@/modules/account/hooks/usePermissions";
import { Bug, Mail, NotepadText } from "lucide-react";
import { useTranslation } from "react-i18next";

export const useAdministrationMenuItems = (): NavigationAnchor[] => {
  const { t } = useTranslation();
  const permissions = usePermissions();
  const isAdmin = useIsAdmin();

  return [
    {
      icon: NotepadText,
      url: PATH_AUDIT_LOGS,
      permission: permissions[Module.AuditLogs].can_read,
      title: t("navigation.auditLogs"),
    },
    {
      icon: Mail,
      url: PATH_EMAIL_RECIPIENTS,
      permission: permissions[Module.EmailRecipients].can_read,
      title: t("navigation.emailRecipients"),
    },
    {
      icon: Mail,
      url: PATH_EMAIL_TYPES,
      permission: permissions[Module.EmailRecipients].can_read,
      title: t("navigation.emailTypes"),
    },
    {
      icon: Bug,
      url: PATH_SENTRY_PLAYGROUND,
      permission: isAdmin,
      title: t("navigation.sentryPlayground"),
    },
  ];
};
